<template>
  <div class="rz-main">
    <div class="rz-top">
      <div class="rz-topbg">
        <img src="../assets/logo2.jpg" />
      </div>
    </div>
    <div class="rz-state">证书状态：<span id="displayName_red">有效</span></div>

    <div class="rz-infor">
      <div class="rz-item">
        <p>获证组织名称：山东知同文传数字科技有限公司</p>
        <p>证书注册号：0352023ITSM185R0MN</p>
        <p>认证标准：ISO/IEC 20000-1:2018</p>
        <p>
          认证范围：向外部客户提供计算机系统工程相关软硬件运维的信息技术服务管理活动(涉及场所:济南高新区新宇路南首齐鲁软件园大厦8层
          808房间)
        </p>
        <br />
        <p>颁证日期：2023年6月24日</p>
        <!-- <p>最近一次审核结束日期：2021年09月11日</p> -->
        <p></p>
        <p>认证机构名称：兴原认证中心有限公司</p>
      </div>
      <div class="rz-item">
        <p>认证证书有效性的进一步查询可登陆：</p>
        <p>认证机构网站</p>
        <p>www.xqcc.com.cn</p>

        <p>中国国家认证认可监督管理委员会网站</p>
        <p>www.cnca.gov.cn</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>
 
<style  lang = "scss"  scoped>
.rz-main {
  // font-size: 16px;
  width: 100%;
  font-family: "微软雅黑";
  color: #333;
  text-shadow: 0 1px 0 #000;
  background: #fcfcfc;
}
.rz-main .rz-top {
  text-align: right;
  line-height: 2em;
  position: relative;
  margin-bottom: 0.5em;
}
.rz-main .rz-top .rz-topbg img {
  width: 100%;
}
.rz-main .rz-top .rz-bigft {
  font-size: 28px;
  font-weight: bold;
}
.rz-main .rz-top .rz-smft {
  font-size: 22px;
}
.rz-main .rz-state {
  // display: block;
  font-size: 20px;
  text-align: right;
  padding: 0.5em 1em;
}
.rz-main .rz-state span {
  font-size: 22px;
  color: #f8e619;
  font-weight: bold;
}
.rz-main .rz-infor {
  padding: 1em;
}
.rz-main .rz-infor .rz-item {
  line-height: 1.3em;
  margin-bottom: 1em;
}
.rz-main .rz-infor .rz-item p {
  font-size: 18px;
  padding: 0.2em 0;
  margin: 0;
}

#displayName_yellow {
  color: #f8e619;
}
#displayName_red {
  color: #5db95b;
}
#displayName_blue {
  color: #5db95b;
}
</style>